import React from "react";
import {useTranslation} from "react-i18next";
import BottomSheetModal from "connectui/component/modal/BottomSheetModal";
import CreateAutoMessageMenu from "../automessages/CreateAutoMessageMenu";

const MobileAutoMessageModal = ({isOpen, onClose, ...props}) => {
  const {t} = useTranslation();

  return (
    <BottomSheetModal
      isOpen={isOpen}
      title={t("mobile.inbox.auto-message-modal.header")}
      onClose={onClose}
    >
      <CreateAutoMessageMenu closeMenu={onClose} isMobile={true} {...props} />
    </BottomSheetModal>
  );
};

export default MobileAutoMessageModal;
